import { computed } from 'vue';
import { defineStore } from 'pinia';
import { captureException } from '@sentry/vue';
import { getDomain } from '@sembo-private/utils';

import { getCurrentOrigin, redirect } from '@apps/main/modules/helpers/window';

export const useCoreStore = defineStore('CoreStore', () => {
  function redirectToMainPage(): void {
    redirect(getCurrentOrigin());
  }

  function openSupportPage(): void {
    const supportPageUrl = getDomain.getCurrentDomainSpec().SupportPage;
    openInNewTab(supportPageUrl);
  }

  function openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  function handleImageLoadError(src: string): void {
    captureException(
      new Error(`Product card image failed loading from ${src}`)
    );
  }

  // Getters
  const currentDomain = computed(() => getDomain.getCurrentDomainSpec().Domain);

  return {
    // Actions
    handleImageLoadError,
    openSupportPage,
    openInNewTab,
    redirectToMainPage,

    // Getters
    currentDomain,
  };
});
